var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 480,
    viewBox: "0 0 30 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#da1a35",
    d: "M0 0h30v18H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m0 0 20.825 18H30L9.175 0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m1.53 0 20.824 18h6.117L7.646 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTt);
export default __webpack_public_path__ + "static/media/tt.550e9df32b915405fd1f5f17b68570c2.svg";
export { ForwardRef as ReactComponent };